// Copyright ©️ 2026 eVolve MEP, LLC

import { useCallback, useRef } from 'react';

export type BuiltInExtension =
  | 'bimWalk'
  | 'measurementSubmenu'
  | 'cameraSubmenu'
  | 'explode'
  | 'modelStructure'
  | 'section'
  | 'settings'
  | 'properties'
  | 'fullscreen';

/** Used to hide extension controls from the toolbar */
export const useHideExtensions = (extensions: BuiltInExtension[]) => {
  const toHide = useRef(extensions);
  const hideToolbarButton = useCallback((extension: BuiltInExtension, retry = 0) => {
    const el = document.getElementById(`toolbar-${extension}Tool`);
    if (el) {
      el.classList.add('hidden');
      toHide.current = toHide.current.filter((e) => e !== extension);
    } else if (retry < 5) {
      setTimeout(() => {
        // TODO: Revisit this
        // oxlint-disable-next-line react/immutability
        hideToolbarButton(extension, retry + 1);
      }, retry);
    }
  }, []);
  return useCallback(
    () => extensions.filter((e) => toHide.current.includes(e)).forEach(hideToolbarButton),
    [extensions, hideToolbarButton],
  );
};
